import {createRouter, createWebHistory} from 'vue-router'

import routes from '@/router/routes'

export default createRouter({
    history: createWebHistory(),
    routes
})